import SearchIcon from "@mui/icons-material/Search";
import { InputAdornment, OutlinedInput, useTheme } from "@mui/material";
import classNames from "classnames";
import React, { ChangeEvent } from "react";

import { useDebouncedCallback } from "@/shared/hooks";

import { KeywordFilter } from "../filter";

import styles from "./FilterInput.module.css";

interface FilterInputProps {
  /** Callback when filter changes (debounced)  */
  onFilterChange: (filter: KeywordFilter) => void;

  /** Optional class name to apply to the root element */
  className?: classNames.Argument;

  /** Placeholder text for the input. Defaults to "Filter topics by name" */
  placeholder?: string;
}

export const FilterInput = React.forwardRef<HTMLInputElement, FilterInputProps>(
  function FilterInput(props, ref) {
    const theme = useTheme();
    const {
      onFilterChange,
      className,
      placeholder = "Filter topics by name",
    } = props;

    const handleChange = React.useCallback(
      function handleChange(event: ChangeEvent<HTMLInputElement>) {
        const term = event.target.value;
        onFilterChange({ type: "keyword", term });
      },
      [onFilterChange],
    );

    const handleChangeDebounced = useDebouncedCallback(handleChange, 300);

    return (
      <div className={classNames(className)}>
        <OutlinedInput
          inputRef={ref}
          size="small"
          fullWidth
          placeholder={placeholder}
          startAdornment={
            <InputAdornment position="start">
              <SearchIcon className={styles.icon} />
            </InputAdornment>
          }
          sx={{
            backgroundColor: theme.palette.paper.main,
          }}
          onChange={handleChangeDebounced}
          inputProps={{
            className: styles.inputBaseChild,
          }}
        />
      </div>
    );
  },
);
